// Mutation Types Const

// App
export const APP_INIT_LOADING = 'APP_INIT_LOADING'
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS'
export const APP_INIT_FAIL = 'APP_INIT_FAIL'
export const APP_TOGGLE_MENU = 'APP_TOGGLE_MENU'
export const APP_TOGGLE_SEARCH = 'APP_TOGGLE_SEARCH'
export const APP_INTERNAL_MENU = 'APP_INTERNAL_MENU'
export const APP_LOAD_THEME = 'APP_LOAD_THEME'
export const APP_LOGIN_MENU = 'APP_LOGIN_MENU'

// Token
export const USER_TOKEN_ADD = 'USER_TOKEN_ADD'
export const USER_TOKEN_REMOVE = 'USER_TOKEN_REMOVE'
export const USER_TOKEN_DETAILS_UPDATE = 'USER_TOKEN_DETAILS_UPDATE'

// Widgets
export const WIDGET_INIT_LOADING = 'WIDGET_INIT_LOADING'
export const WIDGET_INIT_SUCCESS = 'WIDGET_INIT_SUCCESS'
export const WIDGET_INIT_FAIL = 'WIDGET_INIT_FAIL'
export const WIDGET_ADD = 'WIDGET_ADD'
export const WIDGET_REMOVE = 'WIDGET_REMOVE'
export const WIDGET_ADJUST = 'WIDGET_ADJUST'
export const QUICKLAUNCH_INIT_LOADING = 'QUICKLAUNCH_INIT_LOADING'
export const QUICKLAUNCH_INIT_SUCCESS = 'QUICKLAUNCH_INIT_SUCCESS'
export const QUICKLAUNCH_INIT_FAIL = 'QUICKLAUNCH_INIT_FAIL'
export const QUICKLAUNCH_ADD = 'QUICKLAUNCH_ADD'
export const QUICKLAUNCH_REMOVE = 'QUICKLAUNCH_REMOVE'
export const TODO_INIT_LOADING = 'TODO_INIT_LOADING'
export const TODO_INIT_SUCCESS = 'TODO_INIT_SUCCESS'
export const TODO_INIT_FAIL = 'TODO_INIT_FAIL'
export const TODO_ADD = 'TODO_ADD'
export const TODO_REMOVE = 'TODO_REMOVE'
export const TODO_UPDATE = 'TODO_UPDATE'
export const TODO_UNDO = 'TODO_UNDO'
export const TODO_EDIT = 'TODO_EDIT'
export const TODO_COMPLETED_INIT_LOADING = 'TODO_COMPLETED_INIT_LOADING'
export const TODO_COMPLETED_INIT_SUCCESS = 'TODO_COMPLETED_INIT_SUCCESS'
export const TODO_COMPLETED_INIT_FAIL = 'TODO_COMPLETED_INIT_FAIL'
export const TODO_COMPLETED_UPDATE = 'TODO_COMPLETED_UPDATE'
export const TODO_COMPLETED_LOADMORE_LOADING = 'TODO_COMPLETED_LOADMORE_LOADING'
export const TODO_COMPLETED_LOADMORE_SUCCESS = 'TODO_COMPLETED_LOADMORE_SUCCESS'
export const TODO_COMPLETED_LOADMORE_FAIL = 'TODO_COMPLETED_LOADMORE_FAIL'
export const DEBUG_INIT_LOADING = 'DEBUG_INIT_LOADING'
export const DEBUG_INIT_SUCCESS = 'DEBUG_INIT_SUCCESS'
export const DEBUG_INIT_FAIL = 'DEBUG_INIT_FAIL'
export const MYSR_INIT_LOADING = 'MYSR_INIT_LOADING'
export const MYSR_INIT_SUCCESS = 'MYSR_INIT_SUCCESS'
export const MYSR_INIT_FAIL = 'MYSR_INIT_FAIL'
export const TOTALSR_INIT_LOADING = 'TOTALSR_INIT_LOADING'
export const TOTALSR_INIT_SUCCESS = 'TOTALSR_INIT_SUCCESS'
export const TOTALSR_INIT_FAIL = 'TOTALSR_INIT_FAIL'
export const USERSONLINE_INIT_LOADING = 'USERSONLINE_INIT_LOADING'
export const USERSONLINE_INIT_SUCCESS = 'USERSONLINE_INIT_SUCCESS'
export const USERSONLINE_INIT_FAIL = 'USERSONLINE_INIT_FAIL'
export const TOTALQI_INIT_LOADING = 'TOTALQI_INIT_LOADING'
export const TOTALQI_INIT_SUCCESS = 'TOTALQI_INIT_SUCCESS'
export const TOTALQI_INIT_FAIL = 'TOTALQI_INIT_FAIL'
export const MYQI_INIT_LOADING = 'MYQI_INIT_LOADING'
export const MYQI_INIT_SUCCESS = 'MYQI_INIT_SUCCESS'
export const MYQI_INIT_FAIL = 'MYQI_INIT_FAIL'
export const MYIP_INIT_LOADING = 'MYIP_INIT_LOADING'
export const MYIP_INIT_SUCCESS = 'MYIP_INIT_SUCCESS'
export const MYIP_INIT_FAIL = 'MYIP_INIT_FAIL'
export const TOTALIP_INIT_LOADING = 'TOTALIP_INIT_LOADING'
export const TOTALIP_INIT_SUCCESS = 'TOTALIP_INIT_SUCCESS'
export const TOTALIP_INIT_FAIL = 'TOTALIP_INIT_FAIL'
export const PENDMTR_INIT_LOADING = 'PENDMTR_INIT_LOADING'
export const PENDMTR_INIT_SUCCESS = 'PENDMTR_INIT_SUCCESS'
export const PENDMTR_INIT_FAIL = 'PENDMTR_INIT_FAIL'
export const REVENUECHART_INIT_LOADING = 'REVENUECHART_INIT_LOADING'
export const REVENUECHART_INIT_SUCCESS = 'REVENUECHART_INIT_SUCCESS'
export const REVENUECHART_INIT_FAIL = 'REVENUECHART_INIT_FAIL'
export const INFORCECHART_INIT_LOADING = 'INFORCECHART_INIT_LOADING'
export const INFORCECHART_INIT_SUCCESS = 'INFORCECHART_INIT_SUCCESS'
export const INFORCECHART_INIT_FAIL = 'INFORCECHART_INIT_FAIL'
export const CONVERSIONCHART_INIT_LOADING = 'CONVERSIONCHART_INIT_LOADING'
export const CONVERSIONCHART_INIT_SUCCESS = 'CONVERSIONCHART_INIT_SUCCESS'
export const CONVERSIONCHART_INIT_FAIL = 'CONVERSIONCHART_INIT_FAIL'
export const MYREVENUECHART_INIT_LOADING = 'MYREVENUECHART_INIT_LOADING'
export const MYREVENUECHART_INIT_SUCCESS = 'MYREVENUECHART_INIT_SUCCESS'
export const MYREVENUECHART_INIT_FAIL = 'MYREVENUECHART_INIT_FAIL'
export const MYINFORCECHART_INIT_LOADING = 'MYINFORCECHART_INIT_LOADING'
export const MYINFORCECHART_INIT_SUCCESS = 'MYINFORCECHART_INIT_SUCCESS'
export const MYINFORCECHART_INIT_FAIL = 'MYINFORCECHART_INIT_FAIL'
export const MYCONVERSIONCHART_INIT_LOADING = 'MYCONVERSIONCHART_INIT_LOADING'
export const MYCONVERSIONCHART_INIT_SUCCESS = 'MYCONVERSIONCHART_INIT_SUCCESS'
export const MYCONVERSIONCHART_INIT_FAIL = 'MYCONVERSIONCHART_INIT_FAIL'

export const SMSBALANCE_INIT_LOADING = 'SMSBALANCE_INIT_LOADING'
export const SMSBALANCE_INIT_SUCCESS = 'SMSBALANCE_INIT_SUCCESS'
export const SMSBALANCE_INIT_FAIL = 'SMSBALANCE_INIT_FAIL'

// Search
export const SEARCH_OPEN = 'SEARCH_OPEN'
export const SEARCH_CLOSE = 'SEARCH_CLOSE'
export const SEARCH_CATEGORY_SELECT = 'SEARCH_CATEGORY_SELECT'

// Agency (Nimbus - Quotation)
export const AGENCY_INIT_LOADING = 'AGENCY_INIT_LOADING'
export const AGENCY_INIT_SUCCESS = 'AGENCY_INIT_SUCCESS'
export const AGENCY_INIT_FAIL = 'AGENCY_INIT_FAIL'
export const AGENCY_QUOTESETTINGS_INIT_LOADING = 'AGENCY_QUOTESETTINGS_INIT_LOADING'
export const AGENCY_QUOTESETTINGS_INIT_SUCCESS = 'AGENCY_QUOTESETTINGS_INIT_SUCCESS'
export const AGENCY_QUOTESETTINGS_INIT_FAIL = 'AGENCY_QUOTESETTINGS_INIT_FAIL'
export const AGENCY_QUOTATION_INIT_LOADING = 'AGENCY_QUOTATION_INIT_LOADING'
export const AGENCY_QUOTATION_INIT_SUCCESS = 'AGENCY_QUOTATION_INIT_SUCCESS'
export const AGENCY_QUOTATION_INIT_FAIL = 'AGENCY_QUOTATION_INIT_FAIL'
export const AGENCY_QUOTATION_RESET = 'AGENCY_QUOTATION_RESET'
export const AGENCY_QUOTATION_SAVE_LOADING = 'AGENCY_QUOTATION_SAVE_LOADING'
export const AGENCY_QUOTATION_SAVE_SUCCESS = 'AGENCY_QUOTATION_SAVE_SUCCESS'
export const AGENCY_QUOTATION_SAVE_FAIL = 'AGENCY_QUOTATION_SAVE_FAIL'
export const AGENCY_QUOTATION_LOAD_DATA = 'AGENCY_QUOTATION_LOAD_DATA'
export const AGENCY_SALES_EDIT = 'AGENCY_SALES_EDIT'
export const AGENCY_QUOTATION_LIFECYCLE = 'AGENCY_QUOTATION_LIFECYCLE'
export const AGENCY_QUOTATION_PREM_LOADING = 'AGENCY_QUOTATION_PREM_LOADING'
export const AGENCY_QUOTATION_PREM_SUCCESS = 'AGENCY_QUOTATION_PREM_SUCCESS'
export const AGENCY_QUOTATION_PREM_FAIL = 'AGENCY_QUOTATION_PREM_FAIL'
export const AGENCY_QUOTATION_LEAVEQUOTE = 'AGENCY_QUOTATION_LEAVEQUOTE'
export const AGENCY_QUOTATION_COMMSLOG = 'AGENCY_QUOTATION_COMMSLOG'
export const AGENCY_QUOTATION_DISCADJ = 'AGENCY_QUOTATION_DISCADJ'
export const AGENCY_QUOTATION_RESET_BENEFIT = 'AGENCY_QUOTATION_RESET_BENEFIT'

// Agency (Listing)
export const AGENCY_LISTING_INIT_LOADING = 'AGENCY_LISTING_INIT_LOADING'
export const AGENCY_LISTING_INIT_SUCCESS = 'AGENCY_LISTING_INIT_SUCCESS'
export const AGENCY_LISTING_INIT_FAIL = 'AGENCY_LISTING_INIT_FAIL'

// Agency (Posting)
export const AGENCY_POSTING_INIT_LOADING = 'AGENCY_POSTING_INIT_LOADING'
export const AGENCY_POSTING_INIT_SUCCESS = 'AGENCY_POSTING_INIT_SUCCESS'
export const AGENCY_POSTING_INIT_FAIL = 'AGENCY_POSTING_INIT_FAIL'

// Agency (Update Status)
export const AGENCY_UPDATESTATUS_INIT_LOADING = 'AGENCY_UPDATESTATUS_INIT_LOADING'
export const AGENCY_UPDATESTATUS_INIT_SUCCESS = 'AGENCY_UPDATESTATUS_INIT_SUCCESS'
export const AGENCY_UPDATESTATUS_INIT_FAIL = 'AGENCY_UPDATESTATUS_INIT_FAIL'

// Reports
export const REPORTS_INIT_LOADING = 'REPORTS_INIT_LOADING'
export const REPORTS_INIT_SUCCESS = 'REPORTS_INIT_SUCCESS'
export const REPORTS_INIT_FAIL = 'REPORTS_INIT_FAIL'
export const REPORTS_AGENCY_INIT_LOADING = 'REPORTS_AGENCY_INIT_LOADING'
export const REPORTS_AGENCY_INIT_SUCCESS = 'REPORTS_AGENCY_INIT_SUCCESS'
export const REPORTS_AGENCY_INIT_FAIL = 'REPORTS_AGENCY_INIT_FAIL'
export const REPORTS_HISTORY_INIT_LOADING = 'REPORTS_HISTORY_INIT_LOADING'
export const REPORTS_HISTORY_INIT_SUCCESS = 'REPORTS_HISTORY_INIT_SUCCESS'
export const REPORTS_HISTORY_INIT_FAIL = 'REPORTS_HISTORY_INIT_FAIL'
export const REPORTS_HISTORY_FAVOURITE_INIT_LOADING = 'REPORTS_HISTORY_FAVOURITE_INIT_LOADING'
export const REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS = 'REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS'
export const REPORTS_HISTORY_FAVOURITE_INIT_FAIL = 'REPORTS_HISTORY_FAVOURITE_INIT_FAIL'
export const REPORTS_HISTORY_LOADMORE_LOADING = 'REPORTS_HISTORY_LOADMORE_LOADING'
export const REPORTS_HISTORY_LOADMORE_SUCCESS = 'REPORTS_HISTORY_LOADMORE_SUCCESS'
export const REPORTS_HISTORY_LOADMORE_FAIL = 'REPORTS_HISTORY_LOADMORE_FAIL'
export const REPORTS_HISTORY_UPDATE = 'REPORTS_HISTORY_UPDATE'
export const REPORTS_HISTORY_FAVOURITE_UPDATE = 'REPORTS_HISTORY_FAVOURITE_UPDATE'
export const REPORTS_CLAIMS_INIT_LOADING = 'REPORTS_CLAIMS_INIT_LOADING'
export const REPORTS_CLAIMS_INIT_SUCCESS = 'REPORTS_CLAIMS_INIT_SUCCESS'
export const REPORTS_CLAIMS_INIT_FAIL = 'REPORTS_CLAIMS_INIT_FAIL'

// Quotation - Motor
export const QUOTE_MOTOR_PARAM = 'QUOTE_MOTOR_PARAM'
export const QUOTE_MOTOR_PARAM_PERMSTATS = 'QUOTE_MOTOR_PARAM_PERMSTATS'
export const QUOTE_MOTOR_PARAM_MAKE = 'QUOTE_MOTOR_PARAM_MAKE'
export const QUOTE_MOTOR_PARAM_GENERAL = 'QUOTE_MOTOR_PARAM_GENERAL'
export const QUOTE_MOTOR_PARAM_VEHICLE = 'QUOTE_MOTOR_PARAM_VEHICLE'
export const QUOTE_MOTOR_PARAM_STATS = 'QUOTE_MOTOR_PARAM_STATS'
export const QUOTE_MOTOR_PARAM_STATS_LOADING = 'QUOTE_MOTOR_PARAM_STATS_LOADING'
export const QUOTE_MOTOR_PARAM_STATS_FAIL = 'QUOTE_MOTOR_PARAM_STATS_FAIL'
export const QUOTE_MOTOR_PARAM_EXCESS = 'QUOTE_MOTOR_PARAM_EXCESS'
export const QUOTE_MOTOR_PARAM_EXCESS_LOADING = 'QUOTE_MOTOR_PARAM_EXCESS_LOADING'
export const QUOTE_MOTOR_PARAM_EXCESS_FAIL = 'QUOTE_MOTOR_PARAM_EXCESS_FAIL'
export const QUOTE_MOTOR_PARAM_ADDBEN = 'QUOTE_MOTOR_PARAM_ADDBEN'
export const QUOTE_MOTOR_PARAM_ADDBEN_LOADING = 'QUOTE_MOTOR_PARAM_ADDBEN_LOADING'
export const QUOTE_MOTOR_PARAM_ADDBEN_FAIL = 'QUOTE_MOTOR_PARAM_ADDBEN_FAIL'
export const QUOTE_MOTOR_PARAM_PLAN_LOADING = 'QUOTE_MOTOR_PARAM_PLAN_LOADING'
export const QUOTE_MOTOR_PARAM_PLAN_SUCCESS = 'QUOTE_MOTOR_PARAM_PLAN_SUCCESS'
export const QUOTE_MOTOR_PARAM_PLAN_FAIL = 'QUOTE_MOTOR_PARAM_PLAN_FAIL'
export const QUOTE_MOTOR_GENERAL = 'QUOTE_MOTOR_GENERAL'
export const QUOTE_MOTOR_DRIVER = 'QUOTE_MOTOR_DRIVER'
export const QUOTE_MOTOR_VEHICLE = 'QUOTE_MOTOR_VEHICLE'
export const QUOTE_MOTOR_STATISTICS = 'QUOTE_MOTOR_STATISTICS'
export const QUOTE_MOTOR_EXCESS = 'QUOTE_MOTOR_EXCESS'
export const QUOTE_MOTOR_PLAN = 'QUOTE_MOTOR_PLAN'
export const QUOTE_MOTOR_ADDBENS = 'QUOTE_MOTOR_ADDBENS'
export const QUOTE_MOTOR_ADDBEN = 'QUOTE_MOTOR_ADDBEN'
export const QUOTE_MOTOR_REMOVEBEN = 'QUOTE_MOTOR_REMOVEBEN'
export const PROPOSAL_MOTOR_GENERAL = 'PROPOSAL_MOTOR_GENERAL'
export const PROPOSAL_MOTOR_PAYMENT = 'PROPOSAL_MOTOR_PAYMENT'

// Quotation - Cargo
export const QUOTE_CARGO_PARAM = 'QUOTE_CARGO_PARAM'
export const QUOTE_CARGO_PARAM_GENERAL = 'QUOTE_CARGO_PARAM_GENERAL'
export const QUOTE_CARGO_PARAM_SHIPMENT = 'QUOTE_CARGO_PARAM_SHIPMENT'
export const QUOTE_CARGO_PARAM_VESSEL = 'QUOTE_CARGO_PARAM_VESSEL'
export const QUOTE_CARGO_PARAM_CLAUSE = 'QUOTE_CARGO_PARAM_CLAUSE'
export const QUOTE_CARGO_PARAM_INSURED = 'QUOTE_CARGO_PARAM_INSURED'
export const QUOTE_CARGO_GENERAL_SIDECLARED = 'QUOTE_CARGO_GENERAL_SIDECLARED'
export const QUOTE_CARGO_GENERAL_LOADMASTER = 'QUOTE_CARGO_GENERAL_LOADMASTER'
export const QUOTE_CARGO_GENERAL = 'QUOTE_CARGO_GENERAL'
export const QUOTE_CARGO_SHIPMENT = 'QUOTE_CARGO_SHIPMENT'
export const QUOTE_CARGO_CLAUSE = 'QUOTE_CARGO_CLAUSE'
export const QUOTE_CARGO_INSURED = 'QUOTE_CARGO_INSURED'
export const QUOTE_CARGO_PREMIUM = 'QUOTE_CARGO_PREMIUM'
export const QUOTE_CARGO_PREMIUM_MANUALRATE = 'QUOTE_CARGO_PREMIUM_MANUALRATE'
export const QUOTE_CARGO_DEFCLAUSE = 'QUOTE_CARGO_DEFCLAUSE'
export const QUOTE_CARGO_PARAM_DEFCLAUSE = 'QUOTE_CARGO_PARAM_DEFCLAUSE'
export const QUOTE_CARGO_PARAM_DEFCLAUSE_LOADING = 'QUOTE_CARGO_PARAM_DEFCLAUSE_LOADING'
export const QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL = 'QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL'

// Quotation - Fire
export const QUOTE_FIRE_PARAM = 'QUOTE_FIRE_PARAM'
export const QUOTE_FIRE_PARAM_GENERAL = 'QUOTE_FIRE_PARAM_GENERAL'
export const QUOTE_FIRE_PARAM_PLAN_LOADING = 'QUOTE_FIRE_PARAM_PLAN_LOADING'
export const QUOTE_FIRE_PARAM_PLAN_SUCCESS = 'QUOTE_FIRE_PARAM_PLAN_SUCCESS'
export const QUOTE_FIRE_PARAM_PLAN_FAIL = 'QUOTE_FIRE_PARAM_PLAN_FAIL'
export const QUOTE_FIRE_GENERAL = 'QUOTE_FIRE_GENERAL'
export const QUOTE_FIRE_PLANS = 'QUOTE_FIRE_PLANS'
export const QUOTE_FIRE_RISK = 'QUOTE_FIRE_RISK'
export const QUOTE_FIRE_PAYMENT = 'QUOTE_FIRE_PAYMENT'
export const QUOTE_FIRE_ADJ_CANCEL = 'QUOTE_FIRE_ADJ_CANCEL'
export const QUOTE_FIRE_RECALCULATE_LOADING = 'QUOTE_FIRE_RECALCULATE_LOADING'
export const QUOTE_FIRE_RECALCULATE_SUCCESS = 'QUOTE_FIRE_RECALCULATE_SUCCESS'
export const QUOTE_FIRE_RECALCULATE_FAIL = 'QUOTE_FIRE_RECALCULATE_FAIL'

// Quotation - Maid
export const QUOTE_MAID_PARAM = 'QUOTE_MAID_PARAM'
export const QUOTE_MAID_PARAM_GENERAL = 'QUOTE_MAID_PARAM_GENERAL'
export const QUOTE_MAID_GENERAL = 'QUOTE_MAID_GENERAL'
export const QUOTE_MAID_PARAM_PLAN_LOADING = 'QUOTE_MAID_PARAM_PLAN_LOADING'
export const QUOTE_MAID_PARAM_PLAN_SUCCESS = 'QUOTE_MAID_PARAM_PLAN_SUCCESS'
export const QUOTE_MAID_PARAM_PLAN_FAIL = 'QUOTE_MAID_PARAM_PLAN_FAIL'
export const QUOTE_MAID_PLANS = 'QUOTE_MAID_PLANS'
export const QUOTE_MAID_RISK = 'QUOTE_MAID_RISK'
export const QUOTE_MAID_PAYMENT = 'QUOTE_MAID_PAYMENT'
export const QUOTE_MAID_ADJ_CANCEL = 'QUOTE_MAID_ADJ_CANCEL'
export const QUOTE_MAID_RECALCULATE_LOADING = 'QUOTE_MAID_RECALCULATE_LOADING'
export const QUOTE_MAID_RECALCULATE_SUCCESS = 'QUOTE_MAID_RECALCULATE_SUCCESS'
export const QUOTE_MAID_RECALCULATE_FAIL = 'QUOTE_MAID_RECALCULATE_FAIL'

// Quotation - Travel
export const QUOTE_TRAVEL_PARAM = 'QUOTE_TRAVEL_PARAM'
export const QUOTE_TRAVEL_PARAM_GENERAL = 'QUOTE_TRAVEL_PARAM_GENERAL'
export const QUOTE_TRAVEL_GENERAL = 'QUOTE_TRAVEL_GENERAL'
export const QUOTE_TRAVEL_PARAM_PLAN_LOADING = 'QUOTE_TRAVEL_PARAM_PLAN_LOADING'
export const QUOTE_TRAVEL_PARAM_PLAN_SUCCESS = 'QUOTE_TRAVEL_PARAM_PLAN_SUCCESS'
export const QUOTE_TRAVEL_PARAM_PLAN_FAIL = 'QUOTE_TRAVEL_PARAM_PLAN_FAIL'
export const QUOTE_TRAVEL_PLANS = 'QUOTE_TRAVEL_PLANS'
export const QUOTE_TRAVEL_APPLICANT = 'QUOTE_TRAVEL_APPLICANT'
export const QUOTE_TRAVEL_INSURED_ADD = 'QUOTE_TRAVEL_INSURED_ADD'
export const QUOTE_TRAVEL_INSURED_REMOVE = 'QUOTE_TRAVEL_INSURED_REMOVE'
export const QUOTE_TRAVEL_INSURED_UPDATE = 'QUOTE_TRAVEL_INSURED_UPDATE'
export const QUOTE_TRAVEL_PAYMENT = 'QUOTE_TRAVEL_PAYMENT'
export const QUOTE_TRAVEL_ADJ_CANCEL = 'QUOTE_TRAVEL_ADJ_CANCEL'
export const QUOTE_TRAVEL_RECALCULATE_LOADING = 'QUOTE_TRAVEL_RECALCULATE_LOADING'
export const QUOTE_TRAVEL_RECALCULATE_SUCCESS = 'QUOTE_TRAVEL_RECALCULATE_SUCCESS'
export const QUOTE_TRAVEL_RECALCULATE_FAIL = 'QUOTE_TRAVEL_RECALCULATE_FAIL'

// Quotation - Package
export const QUOTE_PACKAGE_PARAM = 'QUOTE_PACKAGE_PARAM'
export const QUOTE_PACKAGE_PARAM_GENERAL = 'QUOTE_PACKAGE_PARAM_GENERAL'
export const QUOTE_PACKAGE_PARAM_PLAN_LOADING = 'QUOTE_PACKAGE_PARAM_PLAN_LOADING'
export const QUOTE_PACKAGE_PARAM_PLAN_SUCCESS = 'QUOTE_PACKAGE_PARAM_PLAN_SUCCESS'
export const QUOTE_PACKAGE_PARAM_PLAN_FAIL = 'QUOTE_PACKAGE_PARAM_PLAN_FAIL'
export const QUOTE_PACKAGE_GENERAL = 'QUOTE_PACKAGE_GENERAL'
export const QUOTE_PACKAGE_PLANS = 'QUOTE_PACKAGE_PLANS'
export const QUOTE_PACKAGE_APPLICANT = 'QUOTE_PACKAGE_APPLICANT'
export const QUOTE_PACKAGE_FIRE_RISK = 'QUOTE_PACKAGE_FIRE_RISK'
export const QUOTE_PACKAGE_PAYMENT = 'QUOTE_PACKAGE_PAYMENT'
export const QUOTE_PACKAGE_ADJ_INIT = 'QUOTE_PACKAGE_ADJ_INIT'
export const QUOTE_PACKAGE_ADJ_CANCEL = 'QUOTE_PACKAGE_ADJ_CANCEL'
export const QUOTE_PACKAGE_ADJ = 'QUOTE_PACKAGE_ADJ'
export const QUOTE_PACKAGE_RECALCULATE_LOADING = 'QUOTE_PACKAGE_RECALCULATE_LOADING'
export const QUOTE_PACKAGE_RECALCULATE_SUCCESS = 'QUOTE_PACKAGE_RECALCULATE_SUCCESS'
export const QUOTE_PACKAGE_RECALCULATE_FAIL = 'QUOTE_PACKAGE_RECALCULATE_FAIL'

// Quotation - PA
export const QUOTE_PA_PARAM = 'QUOTE_PA_PARAM'
export const QUOTE_PA_PARAM_GENERAL = 'QUOTE_PA_PARAM_GENERAL'
export const QUOTE_PA_GENERAL = 'QUOTE_PA_GENERAL'
export const QUOTE_PA_PARAM_PLAN_LOADING = 'QUOTE_PA_PARAM_PLAN_LOADING'
export const QUOTE_PA_PARAM_PLAN_SUCCESS = 'QUOTE_PA_PARAM_PLAN_SUCCESS'
export const QUOTE_PA_PARAM_PLAN_FAIL = 'QUOTE_PA_PARAM_PLAN_FAIL'
export const QUOTE_PA_PLANS = 'QUOTE_PA_PLANS'
export const QUOTE_PA_APPLICANT = 'QUOTE_PA_APPLICANT'
export const QUOTE_PA_INSURED_ADD = 'QUOTE_PA_INSURED_ADD'
export const QUOTE_PA_INSURED_REMOVE = 'QUOTE_PA_INSURED_REMOVE'
export const QUOTE_PA_INSURED_UPDATE = 'QUOTE_PA_INSURED_UPDATE'
export const QUOTE_PA_PAYMENT = 'QUOTE_PA_PAYMENT'
export const QUOTE_PA_ADJ_CANCEL = 'QUOTE_PA_ADJ_CANCEL'
export const QUOTE_PA_OPT_CVRS = 'QUOTE_PA_OPT_CVRS'
export const QUOTE_PA_RECALCULATE_LOADING = 'QUOTE_PA_RECALCULATE_LOADING'
export const QUOTE_PA_RECALCULATE_SUCCESS = 'QUOTE_PA_RECALCULATE_SUCCESS'
export const QUOTE_PA_RECALCULATE_FAIL = 'QUOTE_PA_RECALCULATE_FAIL'

// Claims
export const CLAIMS_INIT_LOADING = 'CLAIMS_INIT_LOADING'
export const CLAIMS_INIT_SUCCESS = 'CLAIMS_INIT_SUCCESS'
export const CLAIMS_INIT_FAIL = 'CLAIMS_INIT_FAIL'
export const CLAIMS_CLAIMENTRY_INIT_LOADING = 'CLAIMS_CLAIMENTRY_INIT_LOADING'
export const CLAIMS_CLAIMENTRY_INIT_SUCCESS = 'CLAIMS_CLAIMENTRY_INIT_SUCCESS'
export const CLAIMS_CLAIMENTRY_INIT_FAIL = 'CLAIMS_CLAIMENTRY_INIT_FAIL'
export const CLAIMS_CLAIMDETAIL_RESET = 'CLAIMS_CLAIMDETAIL_RESET'
export const CLAIMS_CLAIMDETAIL_INIT_LOADING = 'CLAIMS_CLAIMDETAIL_INIT_LOADING'
export const CLAIMS_CLAIMDETAIL_INIT_SUCCESS = 'CLAIMS_CLAIMDETAIL_INIT_SUCCESS'
export const CLAIMS_CLAIMDETAIL_INIT_FAIL = 'CLAIMS_CLAIMDETAIL_INIT_FAIL'
export const CLAIMS_CLAIMDETAIL_SAVE_LOADING = 'CLAIMS_CLAIMDETAIL_SAVE_LOADING'
export const CLAIMS_CLAIMDETAIL_SAVE_SUCCESS = 'CLAIMS_CLAIMDETAIL_SAVE_SUCCESS'
export const CLAIMS_CLAIMDETAIL_SAVE_FAIL = 'CLAIMS_CLAIMDETAIL_SAVE_FAIL'
export const CLAIMS_CLAIMDETAIL_LOAD_DATA = 'CLAIMS_CLAIMDETAIL_LOAD_DATA'
export const CLAIMS_CLAIMDETAIL_LIFECYCLE = 'CLAIMS_CLAIMDETAIL_LIFECYCLE'
export const CLAIMS_CLAIMDETAIL_LEAVEQUOTE = 'CLAIMS_CLAIMDETAIL_LEAVEQUOTE'
export const CLAIMS_CLAIMDETAIL_CLAIMANT = 'CLAIMS_CLAIMDETAIL_CLAIMANT'
export const CLAIMS_CLAIMDETAIL_CLAIMITEM = 'CLAIMS_CLAIMDETAIL_CLAIMITEM'
export const CLAIMS_LISTING_INIT_LOADING = 'CLAIMS_LISTING_INIT_LOADING'
export const CLAIMS_LISTING_INIT_SUCCESS = 'CLAIMS_LISTING_INIT_SUCCESS'
export const CLAIMS_LISTING_INIT_FAIL = 'CLAIMS_LISTING_INIT_FAIL'
export const CLAIMS_CLAIMDETAIL_PARAM = 'CLAIMS_CLAIMDETAIL_PARAM'
export const CLAIMS_CLAIMDETAIL_PARAM_NOL1 = 'CLAIMS_CLAIMDETAIL_PARAM_NOL1'
export const CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING = 'CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING'
export const CLAIMS_CLAIMDETAIL_PARAM_RESERVE = 'CLAIMS_CLAIMDETAIL_PARAM_RESERVE'
export const CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL = 'CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL'
export const CLAIMS_CLAIMDETAIL_RESERVE = 'CLAIMS_CLAIMDETAIL_RESERVE'
export const CLAIMS_CLAIMDETAIL_CLAIMRESERVE = 'CLAIMS_CLAIMDETAIL_CLAIMRESERVE'
export const CLAIMS_CLAIMDETAIL_LEAVECLAIM = 'CLAIMS_CLAIMDETAIL_LEAVECLAIM'
export const CLAIMS_UPDATESTATUS_INIT_LOADING = 'CLAIMS_UPDATESTATUS_INIT_LOADING'
export const CLAIMS_UPDATESTATUS_INIT_SUCCESS = 'CLAIMS_UPDATESTATUS_INIT_SUCCESS'
export const CLAIMS_UPDATESTATUS_INIT_FAIL = 'CLAIMS_UPDATESTATUS_INIT_FAIL'
export const CLAIMS_POSTING_INIT_LOADING = 'CLAIMS_POSTING_INIT_LOADING'
export const CLAIMS_POSTING_INIT_SUCCESS = 'CLAIMS_POSTING_INIT_SUCCESS'
export const CLAIMS_POSTING_INIT_FAIL = 'CLAIMS_POSTING_INIT_FAIL'
export const CLAIMS_STAGING_INIT_LOADING = 'CLAIMS_STAGING_INIT_LOADING'
export const CLAIMS_STAGING_INIT_SUCCESS = 'CLAIMS_STAGING_INIT_SUCCESS'
export const CLAIMS_STAGING_INIT_FAIL = 'CLAIMS_STAGING_INIT_FAIL'

// User
export const USER_PROFILE_LOADING = 'USER_PROFILE_LOADING'
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS'
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL'
export const USER_PASSWORD_SUCCESS = 'USER_PASSWORD_SUCCESS'
export const USER_SESSION_EXPIRED = 'USER_SESSION_EXPIRED'
export const USER_NOTIFICATION_LOADING = 'USER_NOTIFICATION_LOADING'
export const USER_NOTIFICATION_SUCCESS = 'USER_NOTIFICATION_SUCCESS'
export const USER_NOTIFICATION_FAIL = 'USER_NOTIFICATION_FAIL'
export const USER_NOTIFICATION_UNFLAGNEW = 'USER_NOTIFICATION_UNFLAGNEW'
export const USER_NOTIFICATION_FLAGREAD = 'USER_NOTIFICATION_FLAGREAD'
export const USER_NOTIFICATION_FLAGALLREAD = 'USER_NOTIFICATION_FLAGALLREAD'
export const USER_NOTIFICATION_LOADMORE_LOADING = 'USER_NOTIFICATION_LOADMORE_LOADING'
export const USER_NOTIFICATION_LOADMORE_SUCCESS = 'USER_NOTIFICATION_LOADMORE_SUCCESS'
export const USER_NOTIFICATION_LOADMORE_FAIL = 'USER_NOTIFICATION_LOADMORE_FAIL'
export const USER_RPT_PROCESS_CLOSE = 'USER_RPT_PROCESS_CLOSE'
export const USER_RPT_PROCESS = 'USER_RPT_PROCESS'
export const USER_RPT_PROCESS_REMOVE = 'USER_RPT_PROCESS_REMOVE'
export const USER_RPT_PROCESS_DOWNLOADSTATUS = 'USER_RPT_PROCESS_DOWNLOADSTATUS'

// Admin User
export const ADMINUSER_INIT_LOADING = 'ADMINUSER_INIT_LOADING'
export const ADMINUSER_INIT_SUCCESS = 'ADMINUSER_INIT_SUCCESS'
export const ADMINUSER_INIT_FAIL = 'ADMINUSER_INIT_FAIL'
export const ADMINUSER_INTERMEDIARY = 'ADMINUSER_INTERMEDIARY'
export const ADMINUSER_SECURITY_LOADING = 'ADMINUSER_SECURITY_LOADING'
export const ADMINUSER_SECURITY_SUCCESS = 'ADMINUSER_SECURITY_SUCCESS'
export const ADMINUSER_SECURITY_FAIL = 'ADMINUSER_SECURITY_FAIL'
export const ADMINUSER_PRIVILEGE_LOADING = 'ADMINUSER_PRIVILEGE_LOADING'
export const ADMINUSER_PRIVILEGE_SUCCESS = 'ADMINUSER_PRIVILEGE_SUCCESS'
export const ADMINUSER_PRIVILEGE_FAIL = 'ADMINUSER_PRIVILEGE_FAIL'

// Admin Intermediary
export const ADMININTERMEDIARY_INIT_LOADING = 'ADMININTERMEDIARY_INIT_LOADING'
export const ADMININTERMEDIARY_INIT_SUCCESS = 'ADMININTERMEDIARY_INIT_SUCCESS'
export const ADMININTERMEDIARY_INIT_FAIL = 'ADMININTERMEDIARY_INIT_FAIL'
export const ADMININTERMEDIARY_INTERGROUPLIST = 'ADMININTERMEDIARY_INTERGROUPLIST'
export const ADMININTERMEDIARY_MENU_INIT_LOADING = 'ADMININTERMEDIARY_MENU_INIT_LOADING'
export const ADMININTERMEDIARY_MENU_INIT_SUCCESS = 'ADMININTERMEDIARY_MENU_INIT_SUCCESS'
export const ADMININTERMEDIARY_MENU_INIT_FAIL = 'ADMININTERMEDIARY_MENU_INIT_FAIL'

// Admin Member
export const ADMINMEMBER_INIT_LOADING = 'ADMINMEMBER_INIT_LOADING'
export const ADMINMEMBER_INIT_SUCCESS = 'ADMINMEMBER_INIT_SUCCESS'
export const ADMINMEMBER_INIT_FAIL = 'ADMINMEMBER_INIT_FAIL'

// Admin B2C Management
export const ADMINB2C_INIT_LOADING = 'ADMINB2C_INIT_LOADING'
export const ADMINB2C_INIT_SUCCESS = 'ADMINB2C_INIT_SUCCESS'
export const ADMINB2C_INIT_FAIL = 'ADMINB2C_INIT_FAIL'
export const ADMINB2C_KEYS_INIT_LOADING = 'ADMINB2C_KEYS_INIT_LOADING'
export const ADMINB2C_KEYS_INIT_SUCCESS = 'ADMINB2C_KEYS_INIT_SUCCESS'
export const ADMINB2C_KEYS_INIT_FAIL = 'ADMINB2C_KEYS_INIT_FAIL'
export const ADMINB2C_KEYS_INTERMEDIARY = 'ADMINB2C_KEYS_INTERMEDIARY'
export const ADMINB2C_REF_INIT_LOADING = 'ADMINB2C_REF_INIT_LOADING'
export const ADMINB2C_REF_INIT_SUCCESS = 'ADMINB2C_REF_INIT_SUCCESS'
export const ADMINB2C_REF_INIT_FAIL = 'ADMINB2C_REF_INIT_FAIL'
export const ADMINB2C_REF_KEYS = 'ADMINB2C_REF_KEYS'
export const ADMINB2C_KEYPRODUCTS_INIT_LOADING = 'ADMINB2C_KEYPRODUCTS_INIT_LOADING'
export const ADMINB2C_KEYPRODUCTS_INIT_SUCCESS = 'ADMINB2C_KEYPRODUCTS_INIT_SUCCESS'
export const ADMINB2C_KEYPRODUCTS_INIT_FAIL = 'ADMINB2C_KEYPRODUCTS_INIT_FAIL'
export const ADMINB2C_KEYPRODUCTS_KEYS = 'ADMINB2C_KEYPRODUCTS_KEYS'

// members
export const TABMENU = 'TABMENU'
export const MISCTAB = 'MISCTAB'
export const TRANSLINK = 'TRANSLINK'

// Parameters
export const PARAMETERS_INIT_LOADING = 'PARAMETERS_INIT_LOADING'
export const PARAMETERS_INIT_SUCCESS = 'PARAMETERS_INIT_SUCCESS'
export const PARAMETERS_INIT_FAIL = 'PARAMETERS_INIT_FAIL'
export const PARAMETERS_APPID = 'PARAMETERS_APPID'
export const PARAMETERS_TARIFFLIST = 'PARAMETERS_TARIFFLIST'
export const PARAMETERS_VEHGRPLIST = 'PARAMETERS_VEHGRPLIST'
export const PARAMETERS_COVERSLIST = 'PARAMETERS_COVERSLIST'
export const PARAMETERS_FACTORLIST = 'PARAMETERS_FACTORLIST'

// Duration
export const MISC_DURATION_INIT_LOADING = 'MISC_DURATION_INIT_LOADING'
export const MISC_DURATION_INIT_SUCCESS = 'MISC_DURATION_INIT_SUCCESS'
export const MISC_DURATION_INIT_FAIL = 'MISC_DURATION_INIT_FAIL'
export const MISC_DURATION_LIST = 'MISC_DURATION_LIST'

// ISO Country
export const MISC_INIT_LOADING = 'MISC_INIT_LOADING'
export const MISC_INIT_SUCCESS = 'MISC_INIT_SUCCESS'
export const MISC_INIT_FAIL = 'MISC_INIT_FAIL'
export const MISC_ISOCTYLIST = 'MISC_ISOCTYLIST'

// Vehicle
export const VEHICLE_INIT_LOADING = 'VEHICLE_INIT_LOADING'
export const VEHICLE_INIT_SUCCESS = 'VEHICLE_INIT_SUCCESS'
export const VEHICLE_INIT_FAIL = 'VEHICLE_INIT_FAIL'
export const VEHICLE_PERMITSTATUSLIST = 'VEHICLE_PERMITSTATUSLIST'
export const VEHICLE_BODYTYELIST = 'VEHICLE_BODYTYELIST'
export const VEHICLE_MAKELIST = 'VEHICLE_MAKELIST'
export const VEHICLE_GROUPLIST = 'VEHICLE_GROUPLIST'

// Vessel
export const VESSEL_INIT_LOADING = 'VESSEL_INIT_LOADING'
export const VESSEL_INIT_SUCCESS = 'VESSEL_INIT_SUCCESS'
export const VESSEL_INIT_FAIL = 'VESSEL_INIT_FAIL'
export const VESSEL_DETAILLIST = 'VESSEL_DETAILLIST'
export const VESSEL_CLASSLIST = 'VESSEL_CLASSLIST'
export const VESSEL_CONSTNLIST = 'VESSEL_CONSTNLIST'
export const VESSEL_ENGMAKELIST = 'VESSEL_ENGMAKELIST'
export const VESSEL_ENGMODLIST = 'VESSEL_ENGMODLIST'
export const VESSEL_FLAGLIST = 'VESSEL_FLAGLIST'
export const VESSEL_TYPELIST = 'VESSEL_TYPELIST'

export const VESSEL_SIDEMENU = 'VESSEL_SIDEMENU'
export const VESSEL_VOYAGE_TABMENU = 'VESSEL_VOYAGE_TABMENU'

// Cargo
export const CARGO_INIT_LOADING = 'CARGO_INIT_LOADING'
export const CARGO_INIT_SUCCESS = 'CARGO_INIT_SUCCESS'
export const CARGO_INIT_FAIL = 'CARGO_INIT_FAIL'

// Statistics
export const STATISTICS_INIT_LOADING = 'STATISTICS_INIT_LOADING'
export const STATISTICS_INIT_SUCCESS = 'STATISTICS_INIT_SUCCESS'
export const STATISTICS_INIT_FAIL = 'STATISTICS_INIT_FAIL'

// Coverage
export const COVERAGE_INIT_LOADING = 'COVERAGE_INIT_LOADING'
export const COVERAGE_INIT_SUCCESS = 'COVERAGE_INIT_SUCCESS'
export const COVERAGE_INIT_FAIL = 'COVERAGE_INIT_FAIL'
export const CLAUSELIST = 'CLAUSELIST'

// Benefit
export const BENEFIT_INIT_LOADING = 'BENEFIT_INIT_LOADING'
export const BENEFIT_INIT_SUCCESS = 'BENEFIT_INIT_SUCCESS'
export const BENEFIT_INIT_FAIL = 'BENEFIT_INIT_FAIL'

// Unit of Measure
export const UOM_INIT_LOADING = 'UOM_INIT_LOADING'
export const UOM_INIT_SUCCESS = 'UOM_INIT_SUCCESS'
export const UOM_INIT_FAIL = 'UOM_INIT_FAIL'

// Business Class
export const BUSCLS_INIT_LOADING = 'BUSCLS_INIT_LOADING'
export const BUSCLS_INIT_SUCCESS = 'BUSCLS_INIT_SUCCESS'
export const BUSCLS_INIT_FAIL = 'BUSCLS_INIT_FAIL'
export const BUSCLS_MENU_LOADING = 'BUSCLS_MENU_LOADING'
export const BUSCLS_MENU_SUCCESS = 'BUSCLS_MENU_SUCCESS'
export const BUSCLS_MENU_FAIL = 'BUSCLS_MENU_FAIL'
export const BUSCLS_TARF_LOADING = 'BUSCLS_TARF_LOADING'
export const BUSCLS_TARF_SUCCESS = 'BUSCLS_TARF_SUCCESS'
export const BUSCLS_TARF_FAIL = 'BUSCLS_TARF_FAIL'
export const BUSCLS_COVER_LOADING = 'BUSCLS_COVER_LOADING'
export const BUSCLS_COVER_SUCCESS = 'BUSCLS_COVER_SUCCESS'
export const BUSCLS_COVER_FAIL = 'BUSCLS_COVER_FAIL'
export const BUSCLS_INIT_LIST = 'BUSCLS_INIT_LIST'

// Business Class Tariff
export const TARF_INIT_LOADING = 'TARF_INIT_LOADING'
export const TARF_INIT_SUCCESS = 'TARF_INIT_SUCCESS'
export const TARF_INIT_FAIL = 'TARF_INIT_FAIL'
export const TARF_BENEFIT_LOADING = 'TARF_BENEFIT_LOADING'
export const TARF_BENEFIT_SUCCESS = 'TARF_BENEFIT_SUCCESS'
export const TARF_BENEFIT_FAIL = 'TARF_BENEFIT_FAIL'
export const TARF_FACTOR_LOADING = 'TARF_FACTOR_LOADING'
export const TARF_FACTOR_SUCCESS = 'TARF_FACTOR_SUCCESS'
export const TARF_FACTOR_FAIL = 'TARF_FACTOR_FAIL'

// Scheme
export const SCHEME_INIT_LOADING = 'SCHEME_INIT_LOADING'
export const SCHEME_INIT_SUCCESS = 'SCHEME_INIT_SUCCESS'
export const SCHEME_INIT_FAIL = 'SCHEME_INIT_FAIL'
export const SCHEME_MENU_LOADING = 'SCHEME_MENU_LOADING'
export const SCHEME_MENU_SUCCESS = 'SCHEME_MENU_SUCCESS'
export const SCHEME_MENU_FAIL = 'SCHEME_MENU_FAIL'

// Package
export const PKGPLAN_MENU_LOADING = 'PKGPLAN_MENU_LOADING'
export const PKGPLAN_MENU_SUCCESS = 'PKGPLAN_MENU_SUCCESS'
export const PKGPLAN_MENU_FAIL = 'PKGPLAN_MENU_FAIL'
export const PKGRISK_MENU_LOADING = 'PKGRISK_MENU_LOADING'
export const PKGRISK_MENU_SUCCESS = 'PKGRISK_MENU_SUCCESS'
export const PKGRISK_MENU_FAIL = 'PKGRISK_MENU_FAIL'
export const PKGRISKITEM_MENU_LOADING = 'PKGRISKITEM_MENU_LOADING'
export const PKGRISKITEM_MENU_SUCCESS = 'PKGRISKITEM_MENU_SUCCESS'
export const PKGRISKITEM_MENU_FAIL = 'PKGRISKITEM_MENU_FAIL'
export const STDRISKTEXT_MENU_LOADING = 'STDRISKTEXT_MENU_LOADING'
export const STDRISKTEXT_MENU_SUCCESS = 'STDRISKTEXT_MENU_SUCCESS'
export const STDRISKTEXT_MENU_FAIL = 'STDRISKTEXT_MENU_FAIL'
export const STDITEMTEXT_MENU_LOADING = 'STDITEMTEXT_MENU_LOADING'
export const STDITEMTEXT_MENU_SUCCESS = 'STDITEMTEXT_MENU_SUCCESS'
export const STDITEMTEXT_MENU_FAIL = 'STDITEMTEXT_MENU_FAIL'
export const PKGTARFBEN_MENU_LOADING = 'PKGTARFBEN_MENU_LOADING'
export const PKGTARFBEN_MENU_SUCCESS = 'PKGTARFBEN_MENU_SUCCESS'
export const PKGTARFBEN_MENU_FAIL = 'PKGTARFBEN_MENU_FAIL'
export const PKGTARFFACT_MENU_LOADING = 'PKGTARFFACT_MENU_LOADING'
export const PKGTARFFACT_MENU_SUCCESS = 'PKGTARFFACT_MENU_SUCCESS'
export const PKGTARFFACT_MENU_FAIL = 'PKGTARFFACT_MENU_FAIL'
export const STDRISKTEXT_SET = 'STDRISKTEXT_SET'
export const FACTORLIST_SET = 'FACTORLIST_SET'

// Standard Risk Text
export const STDRISK_INIT_LOADING = 'STDRISK_INIT_LOADING'
export const STDRISK_INIT_SUCCESS = 'STDRISK_INIT_SUCCESS'
export const STDRISK_INIT_FAIL = 'STDRISK_INIT_FAIL'
export const STDRISK_TEXT_INIT_LOADING = 'STDRISK_TEXT_INIT_LOADING'
export const STDRISK_TEXT_INIT_SUCCESS = 'STDRISK_TEXT_INIT_SUCCESS'
export const STDRISK_TEXT_INIT_FAIL = 'STDRISK_TEXT_INIT_FAIL'
export const STDRISK_ITEMTEXT_INIT_LOADING = 'STDRISK_ITEMTEXT_INIT_LOADING'
export const STDRISK_ITEMTEXT_INIT_SUCCESS = 'STDRISK_ITEMTEXT_INIT_SUCCESS'
export const STDRISK_ITEMTEXT_INIT_FAIL = 'STDRISK_ITEMTEXT_INIT_FAIL'

// Product
export const PRODUCT_MENU_INIT_LOADING = 'PRODUCT_MENU_INIT_LOADING'
export const PRODUCT_MENU_INIT_SUCCESS = 'PRODUCT_MENU_INIT_SUCCESS'
export const PRODUCT_MENU_INIT_FAIL = 'PRODUCT_MENU_INIT_FAIL'
export const PRODUCT_MENU_LOADING = 'PRODUCT_MENU_LOADING'
export const PRODUCT_MENU_SUCCESS = 'PRODUCT_MENU_SUCCESS'
export const PRODUCT_MENU_FAIL = 'PRODUCT_MENU_FAIL'

// Promotion Management
export const PROMOTION_MANAGEMENT_INIT_LOADING = 'PROMOTION_MANAGEMENT_INIT_LOADING'
export const PROMOTION_MANAGEMENT_INIT_SUCCESS = 'PROMOTION_MANAGEMENT_INIT_SUCCESS'
export const PROMOTION_MANAGEMENT_INIT_FAIL = 'PROMOTION_MANAGEMENT_INIT_FAIL'
export const CAMPAIGN_INIT_LOADING = 'CAMPAIGN_INIT_LOADING'
export const CAMPAIGN_INIT_SUCCESS = 'CAMPAIGN_INIT_SUCCESS'
export const CAMPAIGN_INIT_FAIL = 'CAMPAIGN_INIT_FAIL'
export const CAMPAIGN_SIDEMENU = 'CAMPAIGN_SIDEMENU'
export const PROMOTION_INIT_LOADING = 'PROMOTION_INIT_LOADING'
export const PROMOTION_INIT_SUCCESS = 'PROMOTION_INIT_SUCCESS'
export const PROMOTION_INIT_FAIL = 'PROMOTION_INIT_FAIL'
export const PROMOTION_SIDEMENU = 'PROMOTION_SIDEMENU'
export const PROMOTION_PROMOFACT = 'PROMOTION_PROMOFACT'
export const PROMOTION_PROMOFACT_TABMENU = 'PROMOTION_PROMOFACT_TABMENU'
export const PROMOTION_FACTORLIST = 'PROMOTION_FACTORLIST'

// Fire
export const FIRE_INIT_LOADING = 'FIRE_INIT_LOADING'
export const FIRE_INIT_SUCCESS = 'FIRE_INIT_SUCCESS'
export const FIRE_INIT_FAIL = 'FIRE_INIT_FAIL'

// PA
export const PA_INIT_LOADING = 'PA_INIT_LOADING'
export const PA_INIT_SUCCESS = 'PA_INIT_SUCCESS'
export const PA_INIT_FAIL = 'PA_INIT_FAIL'

// Intermediary Comm Disc Factors
export const ADMININTERMEDIARY_INTERCOMMDISCFACT = 'ADMININTERMEDIARY_INTERCOMMDISCFACT'
export const ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU = 'ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU'
export const ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST = 'ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST'

// Currency
export const CURRENCY_INIT_LOADING = 'CURRENCY_INIT_LOADING'
export const CURRENCY_INIT_SUCCESS = 'CURRENCY_INIT_SUCCESS'
export const CURRENCY_INIT_FAIL = 'CURRENCY_INIT_FAIL'

// Standard Comm Disc Factors
export const PRODUCT_STDCOMMDISCFACT_TABMENU = 'PRODUCT_STDCOMMDISCFACT_TABMENU'
export const PRODUCT_STDCOMMDISCFACT = 'PRODUCT_STDCOMMDISCFACT'
export const PRODUCT_STDCOMMDISCFACTORLIST = 'PRODUCT_STDCOMMDISCFACTORLIST'

// Travel
export const TRAVEL_INIT_LOADING = 'TRAVEL_INIT_LOADING'
export const TRAVEL_INIT_SUCCESS = 'TRAVEL_INIT_SUCCESS'
export const TRAVEL_INIT_FAIL = 'TRAVEL_INIT_FAIL'

// Claim Param
export const CLAIMPARAM_INIT_LOADING = 'CLAIMPARAM_INIT_LOADING'
export const CLAIMPARAM_INIT_SUCCESS = 'CLAIMPARAM_INIT_SUCCESS'
export const CLAIMPARAM_INIT_FAIL = 'CLAIMPARAM_INIT_FAIL'

// Module General Settings
export const MODGENERAL_INIT_LOADING = 'MODGENERAL_INIT_LOADING'
export const MODGENERAL_INIT_SUCCESS = 'MODGENERAL_INIT_SUCCESS'
export const MODGENERAL_INIT_FAIL = 'MODGENERAL_INIT_FAIL'
